import { render } from "./ProductsSchemajson.vue?vue&type=template&id=00e1a992"
import script from "./ProductsSchemajson.vue?vue&type=script&lang=js"
export * from "./ProductsSchemajson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__